import { Fragment, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Spinner } from "reactstrap";
import { useQueryClient } from "@tanstack/react-query";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { CardSummaryOrder } from "../../Components/order/CardSummaryOrder";
import { CardProductOrder } from "../../Components/order/CardProductOrder";
import { CardShippingOrder } from "../../Components/order/CardShippingOrder";
import { CardUserOrder } from "../../Components/order/CardUserOrder";
import { CardSiigoInvoice } from "../../Components/order/CardSiigoInvoice";
import { OrderStatusTimeline } from "../../Components/order/OrderStatusTimeline";
import { OrderActionsCell } from "../../Components/order/OrderActionsCell";
import { PaymentProofModal } from "../../Components/order/PaymentProofModal";
import { StatusChip } from "../../Components/common/StatusChip";
import { getStatusMeta } from "../../utils/statusMeta";
import { ORDER_STATUS_LABELS } from "../../utils/orderConstants";

export const DetailOrder = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getData } = useDataFetch();
  const queryClient = useQueryClient();
  const [proofModalOpen, setProofModalOpen] = useState(false);

  const { data, isLoading } = getData(["order", id], `/order/${id}`, {
    enabled: !!id,
  });

  const order = data?.data?.order;

  const handleOrderUpdate = () => {
    queryClient.invalidateQueries(["order", id]);
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner color="primary" /> Cargando orden...
      </div>
    );
  }

  if (!order) {
    return (
      <div className="text-center py-5">
        <h5>No se encontró la orden</h5>
        <button type="button" className="ui-back" onClick={() => navigate(-1)}>
          <i className="ri-arrow-left-line" /> Volver
        </button>
      </div>
    );
  }

  const statusMeta = getStatusMeta(order.status);
  const isStorePickupTransfer =
    order.delivery_type === "STORE_PICKUP" && order.payment_method === "TRANSFER";

  const paidMeta =
    order.status === "CANCELLED"
      ? { tone: "danger", icon: "ri-close-circle-line", label: "Cancelada" }
      : order.is_paid
      ? { tone: "success", icon: "ri-checkbox-circle-line", label: "Pagada" }
      : { tone: "warning", icon: "ri-time-line", label: "Sin pagar" };

  return (
    <Fragment>
    <Container fluid={true} className="ui-content" style={{ padding: 0 }}>
      <button type="button" className="ui-back" onClick={() => navigate(-1)}>
        <i className="ri-arrow-left-line" /> Volver a órdenes
      </button>

      <div className="ui-detail-head">
        <div>
          <div className="ui-detail-head__id">ORDEN</div>
          <div className="ui-detail-head__code">{order.id}</div>
        </div>
        <div className="ui-detail-head__chips">
          <StatusChip tone={statusMeta.tone} icon={statusMeta.icon}>
            {ORDER_STATUS_LABELS[order.status] || order.status}
          </StatusChip>
          <StatusChip tone={paidMeta.tone} icon={paidMeta.icon}>
            {paidMeta.label}
          </StatusChip>
        </div>
        <div className="ui-detail-head__actions">
          {isStorePickupTransfer && (
            <button
              type="button"
              className="ui-back"
              style={{ margin: 0, border: "1px solid #E1E4F0", borderRadius: 9, padding: "10px 14px" }}
              onClick={() => setProofModalOpen(true)}
            >
              <i className="ri-file-list-3-line" /> Ver comprobante
            </button>
          )}
          <OrderActionsCell order={order} showDetail={false} />
        </div>
      </div>

      <div className="ui-grid-main ui-grid-main--narrow">
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <CardProductOrder order={order} />

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <CardUserOrder order={order} />
            <CardShippingOrder order={order} />
          </div>

          <OrderStatusTimeline order={order} />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <CardSummaryOrder order={order} />
          <CardSiigoInvoice order={order} onOrderUpdate={handleOrderUpdate} />
        </div>
      </div>

      <PaymentProofModal
        isOpen={proofModalOpen}
        toggle={() => setProofModalOpen(false)}
        order={order}
      />
    </Container>
    </Fragment>
  );
};
